import { UseFormReturn } from "react-hook-form"
import { z } from "zod"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getFormProps = <Tschema extends z.ZodType<any, any, any>>(
  form: UseFormReturn<z.infer<Tschema>>,
  schema: Tschema
) => ({
  form,
  schema
})
